import { t } from "ttag";

import { ForwardRefLink } from "metabase/common/components/Link";
import { Route } from "metabase/hoc/Title";
import { Icon, Menu } from "metabase/ui";

import { AdhocQueryPage } from "./AdhocQueryPage";
import { ADHOC_QUERY_PATH, ADHOC_QUERY_ROUTE_PATH } from "./constants";

/**
 * Routes owned by the jerry ad-hoc query workbench.
 *
 * Exposed as a factory so wiring it into `metabase/routes.jsx` is a single JSX
 * line, which keeps rebases onto upstream Metabase cheap.
 */
export const getAdhocQueryRoutes = () => (
  <Route
    path={ADHOC_QUERY_ROUTE_PATH}
    title={t`Ad-hoc query`}
    component={AdhocQueryPage}
  />
);

/**
 * Entry for the "+ New" menu.
 *
 * Rendering the whole menu item here (rather than inline upstream) keeps the
 * edit to `NewItemMenuView.tsx` down to an import and one line.
 */
export function AdhocQueryMenuItem() {
  return (
    <Menu.Item
      component={ForwardRefLink}
      to={ADHOC_QUERY_PATH}
      leftSection={<Icon name="table2" />}
    >
      {t`Ad-hoc query`}
    </Menu.Item>
  );
}
